import React from "react";

const PUBLIC = process.env.PUBLIC_URL || "";
const HORIZONTAL = `${PUBLIC}/brand/logo-horizontal.png`;
const EMBLEM = `${PUBLIC}/brand/emblem.png`;
const VERTICAL = `${PUBLIC}/brand/logo-vertical.png`;

// Official Cloud Beaker emblem (locked brand asset, used as-is).
export function Emblem({ size = 40, className = "" }) {
  return (
    <img
      src={EMBLEM}
      alt="Cloud Beaker"
      width={size}
      height={size}
      className={className}
      style={{ height: size, width: "auto", objectFit: "contain" }}
    />
  );
}

export function VerticalLogo({ height = 120, className = "" }) {
  return (
    <img src={VERTICAL} alt="Cloud Beaker Corporation" className={className} style={{ height, width: "auto" }} />
  );
}

// Horizontal lockup (official brand asset). showWordmark=false renders the emblem only.
export default function Logo({ size = 40, className = "", showWordmark = true }) {
  if (!showWordmark) return <Emblem size={size} className={className} />;
  return (
    <img
      src={HORIZONTAL}
      alt="Cloud Beaker Corporation"
      className={className}
      style={{ height: size, width: "auto", display: "block" }}
    />
  );
}
